import {
    CREATE_APPOINTMENT_TYPE, 
    FETCH_APPOINTMENT_TYPES, 
    UPDATE_APPOINTMENT_TYPE, 
    UPDATE_APPOINTMENT_TYPES, 
    DESTROY_APPOINTMENT_TYPE,
    SET_ORGANIZATION_CURRENT
} from '../constants/actionTypes'

export default (state = {}, action) => {
    switch (action.type) {
        case CREATE_APPOINTMENT_TYPE:
            return {
                ...state, 
                [`${action.payload.id}`]: action.payload
            }
        case UPDATE_APPOINTMENT_TYPE:
            return {
                ...state, 
                [`${action.payload.id}`]: action.payload
            }
        case UPDATE_APPOINTMENT_TYPES:
            let payload = action.payload.reduce((acc, item)=>{
                acc[item.repeatingID || item.id] = item
                return acc;
            }, {})

            return {
                ...state,
                ...payload
            }
        case DESTROY_APPOINTMENT_TYPE:
            state = {
                ...state
            }
            delete state[action.payload] 
            return state
        case FETCH_APPOINTMENT_TYPES:
            return action.payload || state;
        case SET_ORGANIZATION_CURRENT:
                return {}
        default:
            return state
    }
}
  